/* @flow */

const Widget = require('./Widget');

module.exports = Widget.default;
